'use client';

import { PopoverArrow } from '@radix-ui/react-popover';
import React, { useEffect, useState } from 'react';

import { type NavItem } from '@/api/types/navigationTypes';
import { Icon } from '@/components/Icon/Icon';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/UI/Popover';

import { NavTopCaret } from './NavTopCaret';
import { PackageSelectNavItem } from './PackageSelectNavItem';

interface PackageSelectNavItemsProps {
  activeSubscriptionItems: NavItem[];
  inactiveSubscriptionItems: NavItem[];
}

export function PackageSelectNavItems(props: PackageSelectNavItemsProps): React.ReactNode {
  const { activeSubscriptionItems, inactiveSubscriptionItems } = props;

  const [isOpen, setIsOpen] = useState(false);

  // Preload images for active subscription items
  useEffect(() => {
    activeSubscriptionItems.forEach((item) => {
      if (item.images?.logo) {
        const img = new window.Image();

        img.src = item.images.logo;
      }
    });
  }, [activeSubscriptionItems]);

  const handleClick = (): void => {
    setIsOpen(!isOpen);
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger
        data-analytics="header-package-select-icon-button"
        className="relative flex size-[30px] cursor-pointer items-center justify-center bg-transparent outline-none after:absolute after:block after:p-3 after:content-[''] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 after:md:p-5"
        onClick={handleClick}
      >
        <Icon className="size-[30px]" id="package-select-icon" />
      </PopoverTrigger>

      <PopoverContent
        align="end"
        alignOffset={-25}
        sideOffset={10}
        className="z-[99] mt-2 hidden min-w-[240px] rounded-2xl border border-base-white/10 bg-base-primary/60 shadow-[-2px_4px_24px_-2px_black/65] backdrop-blur-[50px] [--tw-backdrop-blur:blur(50px)] focus:outline-none sm:block"
        style={{ WebkitBackdropFilter: 'blur(50px)' }}
      >
        <PopoverArrow asChild>
          <NavTopCaret />
        </PopoverArrow>

        <ul className="px-[16px] py-2">
          {activeSubscriptionItems.map((item) => (
            <PackageSelectNavItem key={item.nav_item_id} navItem={item} isActive />
          ))}

          {activeSubscriptionItems.length > 0 ? <li className="my-[2px] border-b border-base-white/10" /> : null}

          {inactiveSubscriptionItems.map((item) => (
            <PackageSelectNavItem key={item.nav_item_id} navItem={item} isActive={false}>
              <Icon id="shopping-icon" className="size-[28px]" decorative />
            </PackageSelectNavItem>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
